import { NavLink } from 'react-router-dom';

import logoIcon from '../../logo-icon.png';

const Header = () => {
    return (
        <div className="navbar navbar-inverse navbar-fixed-top">
            <div className="container">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                    <NavLink className="navbar-brand" to="/"><img className="logo-icon" src={logoIcon} /></NavLink>
                </div>
                <div className="navbar-collapse collapse">
                    <ul className="nav navbar-nav navbar-right">
                        <li><NavLink to="/">Inicio</NavLink></li>
                        <li><a href="#services-sec">Serviços</a></li>
                        <li><a href="#contato-sec">Contato</a></li>
                        <li><a href="https://www.facebook.com/pages/Conectiva-Solucoes-Em-Inform%C3%A1tica/602724239908464"
                            target="_blank">Facebook</a></li>
                        <li><NavLink to="/suporte-clinica-do-esporte">Suporte</NavLink></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Header;